import srOnly from '@helpers/srOnly';
import styled from 'styled-components';
const Container = styled.section `
  ${srOnly}
`;
const LiveRegionStyles = {
    Container,
};
export default LiveRegionStyles;
